import { Component } from '@angular/core';

@Component({
  selector: 'app-bank-payment-list',
  standalone: false,
  templateUrl: './bank-payment-list.component.html',
  styleUrl: './bank-payment-list.component.scss'
})
export class BankPaymentListComponent {

}
